import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as d3 from 'd3';
import { DataBridgeService } from '../../services/data-bridge.service';

@Component({
  selector: 'app-floor-layout',
  templateUrl: './floor-layout.component.html',
  styleUrls: ['./floor-layout.component.scss']
})
export class FloorLayoutComponent implements OnInit {


  @Input() FLOOR_DATA;
  @Input() isFloorPlanAvailable;
  @Input() isLoaderRequired = true;
  @Input() seatID = null;
  @Input() preRenderedPlan = null;
  @Input() multiSelectAllowed = false;
  @Input() searchedEmployee;
  @Input() filter;
  @Input() changeOn;
  @Input() timeZone;
  @Input() seatSelectionAllowed: boolean;
  @Input() showSeatDetailsOnHover: boolean = false;
  @Input() fromElement;
  @Input() toElement;
  @Input() directionData;
  @Input() footprintSize;
  @Input() showEmpBookingDetails: boolean;
  @Input() empGuid: string
  @Input() userTagsMap: {[key:string]: string} = {}
  @Input() filteredTags: Set<string>

  @Input() selectedSearchInfo: any;
  @Input() selectedSearchSeat: any;

  @Output() renderCompleteCallback: EventEmitter<any> = new EventEmitter<any>();
  @Output() seatClickEmitter = new EventEmitter();
  @ViewChild('myPinch', { static: false }) myPinch;

  seatStatus: any;
  shouldShowLoader: boolean = true;
  teamSeats=[];
  teamSeatId:any;
  teamPopUpPosition:{};
  teamDisplayText:string;
  teamSeatHeight:any;
  base: any;
  teamBase:any;
  mobileTipLength:any;
  popUpPosition: {};
  platformElement;
  toolTip: any;
  showTeamTooltip:boolean=false;
  teamPopUpDirection:boolean;
  bookingPopUpDirection:boolean;
  view;
  bookingDisplayData: any;
  bookingDisplaySeat: any;
  isSeatClicked: boolean;
  empSearchSeat:any;
  shouldDisplayBookingPopUp: boolean = false;
  currentScale: any;
  mapElement: any;
  layout: { geoJson: { type: string; features: any[]; image: any; }; floorDetails: any; };
  selectedSeat = {};

  selectedSeatOnGrid = {};
  selectedSeatsList = [];
  toBePublishedSeatDataList = [];
  seats = [];
  filteredSeats = [];
  teamSeatsArr = [];
  hotSeatsArr = [];
  otherSeatsArr = [];
  empSearch: boolean = false
  parkingType: string = ''
  empGuidParam: string = ''
  openedFrom: any;
  teamSeatDeselected: boolean = false

  gridParkingLayout: Array<{
    tagName: string
    slots: Array<any>
  }> = []

  constructor(private _dataBridge: DataBridgeService) { }

  ngOnInit() {
    /**For grid view */
    this.teamDisplayText='Your team seats are here';
    const view = this.getQueryStringValue("view");
    this.empGuidParam = this.getQueryStringValue('empGuid')
    this.parkingType = this.getQueryStringValue('type')
    this.empSearch = this.getQueryStringValue("search") === "true"
    if (view.length !== 0 && (view === 'admin-view' || view === 'assignment-view' || view === 'sanitisation-view' || view === 'parking-view' || view === 'preferences-view' || view == "way-finder-view")) {
      this.view = view;
    } else {
      this.view = 'employee-view';
    }
    /******** */
    this.openedFrom=this.getQueryStringValue('openedFrom');
    this.layout = this._dataBridge.convertDataToGeoJson(this.FLOOR_DATA.planDetails, this.FLOOR_DATA.image);
    for(let seat of this.layout.geoJson.features){
      if(seat.properties.status==='AVAILABLE' && seat.properties.groupType==='TEAM'){
        this.teamSeats.push(seat.properties.ID);
      }
    }
    this.teamSeatId=this.teamSeats[0];
    this.FLOOR_DATA.extras.colorMapping && this._dataBridge.setColorMapping(this.FLOOR_DATA.extras.colorMapping);
    this._dataBridge.setAssetsLocation(this.FLOOR_DATA.extras.assetsLocation)
    document.getElementById('loader')?.addEventListener('wheel', (event) => {
      event.preventDefault()
    })
    if (!this.isFloorPlanAvailable) {
      this.seats = [...this._dataBridge.getSeatsList()];
      this.categorizeSeatsForNoFloorPlan(this._dataBridge.getSeatsList());
      this.isPlanRendered({});
    }
    const seatId = this.getQueryStringValue('seatId')
    const tagId = this.getQueryStringValue('tagId')
    if(view === 'parking-view'){
      this.processLayoutForGridParking()
      if (seatId && tagId && this.userTagsMap[tagId]){
        for (let seat of this.seats) {
          if (seat.properties.ID === seatId) {
            let slot = {...seat}
            slot.properties.tag = tagId
            this.selectSeatOnGrid(slot);
            break;
          }
        }
      }
    }
  }
  processLayoutForGridParking(){
    let availableSlots = []
    let bookedSlots = []
    let tagSlotsMap = {}
    this.seats.forEach((slot) => {
      if (slot.properties.status === 'BOOKED') {
        bookedSlots.push(slot)
      } else if (slot.properties.tags && slot.properties.tags.length > 0){
        slot.properties.tags.forEach(tagId => {
          if(!this.userTagsMap[tagId]) return;
          let slotCopy = JSON.parse(JSON.stringify(slot))
          slotCopy.properties['tag'] = tagId
          if(tagSlotsMap[tagId]){
            tagSlotsMap[tagId].slots.push(slotCopy)
          }
          else{
            tagSlotsMap[tagId] = {
              tagName: this.userTagsMap[tagId],
              slots: [slotCopy],
            };
          }
        })
      } else if(slot.properties.status === 'AVAILABLE'){
        availableSlots.push(slot)
      }
    })
    this.gridParkingLayout = Object.values(tagSlotsMap);
    this.gridParkingLayout.push({
      tagName: "Available",
      slots: availableSlots,
    });
    this.gridParkingLayout.push({
      tagName: "Booked",
      slots: bookedSlots,
    });
    console.log(this.gridParkingLayout);
  }


  getQueryStringValue(key) {
    let value = "";
    if (window.location.href) {
      const queryStringPairs = window.location.href.split('?')[1] && window.location.href.split('?')[1].split('&');
      if (queryStringPairs) {
        for (let i = 0; i < queryStringPairs.length; i++) {
          const pair = queryStringPairs[i].split('=');
          if (pair[0] === key) {
            value = pair[1];
            break;
          }
        }
      }
      return value;
    }
    return '';
  }

  scrollHandler = (currentScale = 1) => {
    this.currentScale = currentScale
    if (this.shouldDisplayBookingPopUp) {
      this.populatePopUpPosition()
    }

    this.showTeamTooltip && this.teamPopulatePopUpPosition();
    
  }

  ngOnChanges() {
    this.platformElement = document.getElementById('platform');
    this.mapElement = document.getElementById('planContainer');
    switch (this.changeOn) {
      case "SEARCH":
      case "search":
        this.isSeatClicked=false;
        if(this.selectedSearchInfo === 'seat'){

          this.seatStatus = this.FLOOR_DATA.planDetails.floorSeatsDTOMap[this.selectedSearchSeat.seatId].seatStatus;
        
          let seatElements = document.getElementById(this.selectedSearchSeat.seatId + "SEAT")
          let xSeat = parseFloat(seatElements.attributes.getNamedItem('x').value)
          let ySeat = parseFloat(seatElements.attributes.getNamedItem('y').value)
          let seatWidth = parseFloat(seatElements.attributes.getNamedItem('width').value)
          let seatHeight = parseFloat(seatElements.attributes.getNamedItem('height').value)
          this.myPinch?.setTransformation({
            duration: 2000,
            center: [xSeat - seatWidth, ySeat - seatHeight - 30],
            node: this.platformElement,
            svg: this.mapElement
          });
          if(this.openedFrom !=='web'){
            this.myPinch.pinchZoom.pointZoom({ scale: 1});
            setTimeout(()=>{
              this.myPinch.pinchZoom.pointZoom({ scale: 2, center: [xSeat - seatWidth, ySeat - seatHeight - 30], transitionDuration: 4000 });
            },1000)
          }
          setTimeout(() => {
            this.selectedSearchSeat && this.showSeatsPopUp(seatElements);
          }, 2000);
           

          let stopSeatIdSearch=0;
          const searchSeatIdblink = () => {
            d3.select(document.getElementById(this.selectedSearchSeat.seatId)).select('svg').selectChildren().transition()
            .duration(200)
            .delay(200)
            .style("opacity", "0.5")
            .transition()
            .duration(200)
            .delay(200)
            .style("opacity", "1")
            .on("end", () => {
              if(!(this.selectedSeatsList.length > 0) && !(stopSeatIdSearch > 0)) {
                return searchSeatIdblink()
              }
            })
            setTimeout(function() {
              stopSeatIdSearch+=1;
            }, 3000);
          }
          searchSeatIdblink();
        
        }
        else{
        let seatElement = document.getElementById(this.searchedEmployee?.properties.ID + "SEAT")
        for(let seat of this.layout.geoJson.features){
          if(seat.properties.ID===this.searchedEmployee?.properties.ID){
            this.empSearchSeat = seat.properties.name;
          }
        }
        if(!seatElement) break;
        let x = parseFloat(seatElement.attributes.getNamedItem('x').value)
        let y = parseFloat(seatElement.attributes.getNamedItem('y').value)
        let width = parseFloat(seatElement.attributes.getNamedItem('width').value)
        let height = parseFloat(seatElement.attributes.getNamedItem('height').value)
        this.myPinch?.setTransformation({
          duration: 2000,
          center: [x - width, y - height - 30],
          node: this.platformElement,
          svg: this.mapElement
        });
        if(this.openedFrom !=='web'){
            this.myPinch.pinchZoom.pointZoom({ scale: 1});
            setTimeout(()=>{
              this.myPinch.pinchZoom.pointZoom({ scale: 2, center: [x - width, y - height - 30], transitionDuration: 4000 });
            },1000)
        }

        setTimeout(() => {
          this.searchedEmployee && this.seatClickHandler(this.searchedEmployee, seatElement)
        }, 2000);
        let stopSeatSearch=0;
        const searchSeatblink = () => {
          d3.select(document.getElementById(this.searchedEmployee?.properties.ID)).select('svg').selectChildren().transition()
          .duration(200)
          .delay(200)
          .style("opacity", "0.5")
          .transition()
          .duration(200)
          .delay(200)
          .style("opacity", "1")
          .on("end", () => {
            if(!(this.selectedSeatsList.length > 0) && !(stopSeatSearch > 0)) {
              return searchSeatblink()
            }
          })
          setTimeout(function() {
            stopSeatSearch+=1;
          }, 3000);
        }
        searchSeatblink();
      }
        break;
      case "FILTER":
      case "filter":
        this.resetFilters().then(() => {
          this.seatFilterHandler();
        });
        break;
      case "LAYOUT":
      case "layout":
        this.layout = this._dataBridge.convertDataToGeoJson(this.FLOOR_DATA.planDetails, this.FLOOR_DATA.image);
        break;
      case "findpath":
        this.plotPathBetweenPoints(this.directionData);

    }
  }

  showSeatsPopUp(base){
    if(this.seatStatus === 'BOOKED' && this.showEmpBookingDetails){
      this.isSeatClicked = true;
      this.bookingDisplayData = Object.assign({}, this.FLOOR_DATA.planDetails.floorSeatsDTOMap[this.selectedSearchSeat.seatId].seatBookedBydetails);
      this.bookingDisplaySeat = this.FLOOR_DATA.planDetails.floorSeatsDTOMap[this.selectedSearchSeat.seatId].seatName;
    }
    else{
      this.isSeatClicked = false;
    }
    this.base = base;
    this.populatePopUpPosition();
    this.shouldDisplayBookingPopUp = true;
  }

  ngAfterViewInit() {
    if (!this.isFloorPlanAvailable) {
      if (!(this.FLOOR_DATA.planDetails.floor.floortype == "WITH_BACKGROUND_IMAGE")) {
        let gridSection = document.getElementById('gridSeatView');
        gridSection.addEventListener('scroll', () => { this.scrollHandler(); });
      }
    }

    //ADD TOOLTIP FOR ALL SEATS
    this.toolTip = d3.select(document.getElementById("platform")).append("div")
      .style("position", "fixed")
      .style("text-align", "center")
      .style("min-width", "60px")
      .style("padding", "6px")
      .style("font", "12px Lato,sans-serif")
      .style("background", "lightsteelblue")
      .style("border", "0px")
      .style("border-radius", "2px")
      .style("pointer-events", "none")
      .style("opacity", "0")
      .style("z-index", "99");
  }
  findSeatForZoom() {
    if (this.view !== 'employee-view' || this.empSearch) return null
    let seatId = null
    seatId = this.getQueryStringValue('seatId')

    if (!seatId) {
      for (let feature of this.layout.geoJson.features) {
        if (feature.properties.type === 'SEAT' && feature.properties.groupType === 'TEAM' && feature.properties.status === 'AVAILABLE') {
          seatId = feature.properties.ID
          break;
        }
      }
    }
    console.log("seat id->", seatId)
    return seatId
  }
  
  zoomToSpecificSeat(seatId, zoomLevel) {
    this.platformElement = document.getElementById('platform');
    this.mapElement = document.getElementById('planContainer');
    let zoomSeatId = this.teamSeatId?this.teamSeatId:seatId;
    if(zoomSeatId){
      let seatElement = document.getElementById(zoomSeatId + "SEAT")
      let x = parseFloat(seatElement.attributes.getNamedItem('x').value)
      let y = parseFloat(seatElement.attributes.getNamedItem('y').value)
      let width = parseFloat(seatElement.attributes.getNamedItem('width').value)
      let height = parseFloat(seatElement.attributes.getNamedItem('height').value)
      this.teamSeatHeight = parseFloat(seatElement.attributes.getNamedItem('height').value)

      this.myPinch.pinchZoom.pointZoom({ scale: zoomLevel, center: [x - width, y - height - 30], transitionDuration: 3000 })
      for(let seat of this.teamSeats){
        d3.select(document.getElementById(seat)).select('svg').selectChildren().style("stroke", "#ED711C");
        d3.select(document.getElementById(seat)).select('svg').selectChildren().selectAll('path').classed('cls-1',false).classed('cls-2',false).style("fill","#fff");
        const blink = () => {
          d3.select(document.getElementById(seat)).select('svg').selectChildren().transition()
          .duration(200)
          .delay(200)
          .style("opacity", "0.5")
          .transition()
          .duration(200)
          .delay(200)
          .style("opacity", "1")
          .on("end", () => {
            if(!(this.selectedSeatsList.length > 0)) {
              return blink()
            }
          })
          setTimeout(function() {
            d3.select(document.getElementById(seat)).select('svg').selectChildren()
            .transition()
            .style("opacity", "1")
          }, 5000);
        }
        blink();
      }
      setTimeout(() => {
        
        this.teamDisplayPopUp();
        this.teamSeatId && this.teamPopulatePopUpPosition();
      }, 2000)

      setTimeout(() => {
        this.showTeamTooltip=false;
      }, 5000)
      // this.searchedEmployee && this.seatClickHandler(this.searchedEmployee, seatElement)
    }
  }

  plotPathBetweenPoints(directionData) {
    d3.selectAll('#directions').remove();
    d3.select('#startPoint').remove();
    d3.select('#endPoint').remove();
    d3.select('#youPoint').remove();
    d3.select('#endLabel').remove();
    d3.select('#startLabel').remove();
    
    // let startPoints = this.getMidPointOfPolygon(fromElement);
    // let endPoints = this.getMidPointOfPolygon(toElement);
    let width = this.layout.floorDetails.wkt.split(',')[2].replace('(', '').replace(')', '').split(' ')[0];
    let height = this.layout.floorDetails.wkt.split(',')[2].replace('(', '').replace(')', '').split(' ')[1];
    console.log(this.layout, "layout");
    console.log(directionData , directionData.edges[0] ,  "startLabel");
    
    var startLabelText = directionData.edges[0].onePOI;

    var endLabelText = directionData.edges[directionData.edges.length - 1].otherPOI;
    this._dataBridge.drawPath(this.getCoordinates(directionData), width, height , this.footprintSize);
    this._dataBridge.plotMarkers(directionData, this.getCoordinates(directionData), width, height , startLabelText , endLabelText);
    // let gridMatrix = this.generateFloorMatrix(fromElement,toElement);
    // let pathPoints = this._dataBridge.findPath(startPoints,endPoints,gridMatrix);
    // console.log(pathPoints,"pathPoints");
    this.fitRouteBounds(width, height, this.getCoordinates(directionData));
  }
  fitRouteBounds(width, height, coordinates) {
    let scaledWidth = (d3.select('#planContainer').node() as SVGSVGElement).getBBox().width;
    let scaledHeight = (d3.select('#planContainer').node() as SVGSVGElement).getBBox().height;
    let scalefactorX = scaledWidth / width;
    let scalefactorY = scaledHeight / height;
    let seatElement = document.getElementById('endPoint')
    this.myPinch?.setTransformation({
      duration: 2000,
      center: [seatElement.getBoundingClientRect().x - seatElement.getBoundingClientRect().width - 50, seatElement.getBoundingClientRect().y - seatElement.getBoundingClientRect().height - 30],
      node: this.platformElement,
      svg: this.mapElement
    });
  }
  getCoordinates(data) {
    return this.orderPois(data)
  }
  orderPois(obj) {
    let poisMap = {}, poisInOrder = [];
    obj.pois.forEach(poi => {
      poisMap[poi.identifier] = { xCoord: poi.xCoord, yCoord: poi.yCoord };
    });
    obj.edges.forEach(edge => {
      poisInOrder.push({
        x: poisMap[edge.onePOI].xCoord,
        y: poisMap[edge.onePOI].yCoord,
      });
    });
    poisInOrder.push({
      x: poisMap[obj.edges[obj.edges.length - 1].otherPOI].xCoord,
      y: poisMap[obj.edges[obj.edges.length - 1].otherPOI].yCoord,
    });
    return poisInOrder;
  }

  generateFloorMatrix(fromElement, toElement) {
    let matrix = [];
    d3.select('svg').selectAll('g').each(function (d, i) {
      if (d3.select(this).attr('type')) {
        if (d3.select(this).attr('seatId') != fromElement.seatId || d3.select(this).attr('seatId') != toElement.seatId) {
          matrix.push((d3.select(this).node() as SVGSVGElement).getBBox());
        }
      }
    })
    return matrix;
  }
  getMidPointOfPolygon(element) {
    let bbox = (d3.select('svg').select("[seatId='" + element.seatId + "']").node() as SVGSVGElement).getBBox();
    let xPos = bbox.x;
    let yPos = bbox.y;
    let width = bbox.width;
    let height = bbox.height;
    let x = xPos + (width / 2);
    let y = yPos + (height / 2);
    return { x: x, y: y };
  }

  categorizeSeatsForNoFloorPlan(seats) {
    this.teamSeatsArr = [];
    this.hotSeatsArr = [];
    this.otherSeatsArr = [];
    seats.forEach(seat => {
      if (seat.properties.groupType === 'TEAM' && seat.properties.teamName && seat.properties.teamName.length > 0) {
        this.teamSeatsArr.push(seat);
      }
      else if (seat.properties.groupType === 'HOTSEAT') {
        this.hotSeatsArr.push(seat);
      }
      else {
        this.otherSeatsArr.push(seat);
      }
    });
  }
  updateSelectedSeat() {
    let urlSeatId = this.getQueryStringValue("seatId");
    let seatDetails: any
    let seat: any
    let base: any
    let showPreferredSeat: boolean = true
    d3.select("#planContainer").selectAll('g').each((d, i) => {
      let bookingEmpGuid = ''
      if (d) {
        bookingEmpGuid = (d['properties']?.bookedByDetails && d['properties']?.bookedByDetails[0]?.empGuid) ? d['properties']?.bookedByDetails[0].empGuid : ''
        if (d['properties']?.ID === urlSeatId && d['properties']?.status === 'AVAILABLE') {
          seatDetails = { ...<any>d }
          seat = d3.select(document.getElementById(d['properties']?.ID + 'SEAT'));
          base = document.getElementById(d['properties']?.ID + 'SEAT').parentElement
        }
        if (this.empGuid === bookingEmpGuid) {
          showPreferredSeat = false
        }
      }
    })
    if (showPreferredSeat && seatDetails && seat && base) {
      this.seatClickHandler(
        seatDetails,
        base,
        seatDetails['properties']?.ID,
        seat.attr('imageName'),
        seat.attr('width'),
        seat.attr('height'),
        seat.attr('x'),
        seat.attr('y')
      )
    }
  }

  isPlanRendered(renderedPlanData) {
    this.updateSelectedSeat()
    let seatId = this.findSeatForZoom()
    // let zoomLevel = (this.getQueryStringValue('openedFrom') === 'web') ? 4 : 7
    if(this.view != 'way-finder-view'){
      let zoomLevel = 2
      if (!document.getElementById(seatId + "SEAT")) seatId = null
      if (!seatId) {
        setTimeout(() => {
          this.myPinch && this.myPinch.setZoom({
            scale: this.calculateScaleNeeded(),
            center: [0, 0],
            isResetDisplay: true
          })
        }, 1000);
      }
      this.shouldShowLoader = false;
      this.renderCompleteCallback.emit(this.layout);

      if (this.isFloorPlanAvailable) {
        setTimeout(() => {
          renderedPlanData.svgComponent.nativeElement.style.filter = null;
        }, 200)
        if (!seatId) {
          setTimeout(() => {
            this.myPinch.setZoom({
              scale: this.calculateScaleNeeded(),
              center: [0, 0],
              isResetDisplay: true
            });
          }, 200);
        }
        this.shouldShowLoader = false;
        this.renderCompleteCallback.emit({ layout: this.layout, imageBase64: renderedPlanData.imageBase64, svg: renderedPlanData.svgComponent });
      }
      else {
        this.shouldShowLoader = false;
        this.renderCompleteCallback.emit({ layout: this.layout });
      }
      renderedPlanData.selectedSeat && this.selectedSeatsList.push(JSON.parse(JSON.stringify(renderedPlanData.selectedSeat)));
      setTimeout(() => { if (seatId) this.zoomToSpecificSeat(seatId, zoomLevel) }, 200)
    }
    else{
      console.log("wayfinding zoom implementation ");
      this.shouldShowLoader = false;
      this.renderCompleteCallback.emit(this.layout);
      if (this.isFloorPlanAvailable) {
        setTimeout(() => {
          renderedPlanData.svgComponent.nativeElement.style.filter = null;
        }, 200)
        this.shouldShowLoader = false;
        this.renderCompleteCallback.emit({ layout: this.layout, imageBase64: renderedPlanData.imageBase64, svg: renderedPlanData.svgComponent });
      }
      else {
        this.shouldShowLoader = false;
        this.renderCompleteCallback.emit({ layout: this.layout });
      } 
      renderedPlanData.selectedSeat && this.selectedSeatsList.push(JSON.parse(JSON.stringify(renderedPlanData.selectedSeat)));      
      setTimeout(() => { this.zoomToPoi(renderedPlanData.svgComponent) })
    }
  }

  teamDisplayPopUp(){
    this.showTeamTooltip = this.teamSeatId ? true : false;
    this.teamBase = document.getElementById(this.teamSeatId);
  }

  teamPopulatePopUpPosition() {
    let x, y;
  
    if ((this.platformElement.getBoundingClientRect().right - this.teamBase.getBoundingClientRect().right) > 230) {
      x = this.teamBase.getBoundingClientRect().right ;
      y = this.teamBase.getBoundingClientRect().top;
      this.teamPopUpDirection=true;
    }
    else if ((this.teamBase.getBoundingClientRect().left - this.platformElement.getBoundingClientRect().left) > 230) {
      x = this.teamBase.getBoundingClientRect().left - 235;
      y = this.teamBase.getBoundingClientRect().top;
      this.teamPopUpDirection=false;
    }
    else if ((this.teamBase.getBoundingClientRect().top - this.platformElement.getBoundingClientRect().top) > 100) {
      x = this.teamBase.getBoundingClientRect().left;
      x = x > 5 ? x : 5;
      x = x + 240 < this.platformElement.getBoundingClientRect().right ? x : this.platformElement.getBoundingClientRect().right - 235;
      y = this.teamBase.getBoundingClientRect().top - 115;
    }
    else {
      x = this.teamBase.getBoundingClientRect().left;
      x = x > 5 ? x : 5;
      x = x + 240 < this.platformElement.getBoundingClientRect().right ? x : this.platformElement.getBoundingClientRect().right - 235;
      y = this.teamBase.getBoundingClientRect().bottom;
    }
    this.mobileTipLength=this.getQueryStringValue('openedFrom') === 'web'?0:12;
    this.teamPopUpPosition = {
      xPos: x,
      yPos: y + ((this.teamSeatHeight/2))-this.mobileTipLength
    };
  }

  zoomToPoi(svgComp) {
    var boundingBoxProperties;
    this.platformElement = document.getElementById('platform');
    this.mapElement = document.getElementById('planContainer');
    var x0 = (d3.select('#directions').node() as SVGSVGElement).getBBox().x;
    var y0 = (d3.select('#directions').node() as SVGSVGElement).getBBox().y;
    var x1 = (d3.select('#directions').node() as SVGSVGElement).getBBox().x +(d3.select('#directions').node() as SVGSVGElement).getBBox().width ;
    var y1 = (d3.select('#directions').node() as SVGSVGElement).getBBox().height + (d3.select('#directions').node() as SVGSVGElement).getBBox().y ;
    var h = (d3.select('#planContainer').node() as SVGSVGElement).getBBox().height;
    var w =(d3.select('#planContainer').node() as SVGSVGElement).getBBox().width;
    this.myPinch.pinchZoom.pointZoom({ scale: 2, center: [0,0], transitionDuration: 1 })
   
    const zoom = d3.zoom()
    .scaleExtent([1, 8])
    .on("zoom", zoomed);
    function zoomed(event) {
      const {transform} = event;
      if(!isNaN(transform.k)){
        transform.x = transform.x - 5*transform.k;
        // transform.y = transform.y + 5*transform.k;
        var styleValue = document.getElementById("pinchZoomId").attributes.getNamedItem("style").value;
        var indexOfTransform = styleValue.indexOf("transform: ");
        var startString = styleValue.substring(0,indexOfTransform);
        const g = d3.select("#pinchZoomId");
        boundingBoxProperties = transform;
        g.attr("style", startString + "transform : matrix(" + transform.k + ",0,0," + transform.k  + "," + transform.x + "," + transform.y  + ");");
        console.log(transform , "transform");
      }
    }
    if(d3.select(svgComp)){
      d3.select(svgComp).transition().duration(0).call(
        zoom.transform,
        d3.zoomIdentity
          .translate(w / 2, h / 2)
          .scale(Math.min(8, 0.9 / Math.max((x1 - x0) / w, (y1 - y0) / h)))
          .translate(-(x0 + x1) / 2, -(y0 + y1) / 2),
      );
    }
    setTimeout(() => {
      if(boundingBoxProperties != undefined){ //raygun
        this.myPinch.pinchZoom.boundingBoxZoom({ scale:boundingBoxProperties.k, xVal:boundingBoxProperties.x , yVal: boundingBoxProperties.y,  transitionDuration: 1 });
      }
    } , 200)   
 }


  calculateScaleNeeded() {
    let width, height;
    if(document.getElementById("platform")){
      if (this._dataBridge.getClientToMapWidthRatio() > this._dataBridge.getClientToMapHeightRatio()) {
        height = document.getElementById("platform").clientHeight;
        width = height * this._dataBridge.getAspectRatio();
      }
      else {
        width = document.getElementById("platform").clientWidth;
        height = width / this._dataBridge.getAspectRatio();
      }
      let freeWidthAvailable = document.getElementById("platform").clientWidth - width;
      let freeHeightAvailable = document.getElementById("platform").clientHeight - height;
      if (freeWidthAvailable > freeHeightAvailable)
        return document.getElementById("platform").clientWidth / (width);
      else
        return document.getElementById("platform").clientHeight / (height);
    }
  }

  handleMouseEvent(data) {
    if (data.event.type == 'mouseover') {
      if (this.showSeatDetailsOnHover) {
        this.toolTip.transition()
          .duration(200)
          .style('background', '#14434c')
          .style('color', 'white')
          .style("opacity", 1);
      } else {
        this.toolTip.transition()
          .duration(200)
          .style('background', '#14434c')
          .style('color', 'white')
          .style("opacity", 1);
      }
      let displayHtml = this.showSeatDetailsOnHover ? this.createToolTipHTML(data.additionalData.data, data.additionalData.displayText) : data.additionalData.displayText;
      this.toolTip.html(displayHtml)
        .style("left", `${data.event.pageX + 15}px`)
        .style("top", `${data.event.pageY + 15}px`)
    } else {
      this.toolTip.transition()
        .duration(500)
        .style("opacity", 0);
      if (data.event.type == 'click') {
        this.seatClickHandler(
          data.additionalData.d,
          data.additionalData.base,
          data.additionalData.ID,
          data.additionalData.currentImageName,
          data.additionalData.width,
          data.additionalData.height,
          data.additionalData.xPos,
          data.additionalData.yPos
        )
      }
    }
  }

  createToolTipHTML(data, name) {
    let el = `
      
    `;
    if (name) {
      el += `<div style="text-align:left;padding:2px;">${name}</div>`;
    }
    let bookingDetails = data.properties.bookedByDetails || [];
    bookingDetails.forEach(booking => {
      el += `<div style="text-align:left;padding:2px;">
      ${this.formatDateYear(booking?.startTime, this.timeZone)} - ${this.formatDateYear(booking?.endTime, this.timeZone)} 
      ${booking.employeeName ? '-' + booking.employeeName : ''} ${booking.groupType ? '-' + booking.groupType : ''} ${booking.teamName ? '-' + booking.teamName : ''}</div>`
    });
    return el;
  }

  formatDate(milliSecs, timeZone?) {
    let date = new Date(milliSecs);
    if (timeZone)
      date = new Date(date.toLocaleString('en-US', { timeZone }));
    return ('0' + (date.getDate())).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) +
      " " + ('0' + (date.getHours())).slice(-2) + ":" + ('0' + (date.getMinutes())).slice(-2);

  }
  formatDateYear(milliSecs, timeZone?) {
    let date = new Date(milliSecs);
      if(timeZone)
        date = new Date (date.toLocaleString('en-US', { timeZone }));
      if(this.view === 'assignment-view')
        return ('0'+(date.getDate())).slice(-2) + '/' + ('0'+(date.getMonth()+1)).slice(-2) + '/' + (date.getFullYear())

      return ('0'+(date.getDate())).slice(-2) + '/' + ('0'+(date.getMonth()+1)).slice(-2) + '/' + (date.getFullYear()) +
             " " +  ('0'+(date.getHours())).slice(-2) + ":" + ('0'+(date.getMinutes())).slice(-2);
    
  }

  seatClickHandler(details, base, ID?, currentImage?, width?, height?, xPos?, yPos?) {
    if(this.view === 'sanitisation-view') return;
    this.base = base;
    this.populatePopUpPosition();
    this.isSeatClicked = true;
    if (details.properties.status == 'Not Available') {
      if (details.properties.bookedByDetails && details.properties.bookedByDetails.length > 0) {
        this.bookingDisplayData = Object.assign({}, details.properties.bookedByDetails);
        this.shouldDisplayBookingPopUp = this.showEmpBookingDetails;
      } else if ((!details.properties.bookedByDetails) || details.properties.bookedByDetails.length === 0) {
        this.bookingDisplayData = Object.assign({}, ["Blocked seat"]);
        this.shouldDisplayBookingPopUp = this.showEmpBookingDetails;
      } else {
        this.dismissPopUp({});
        return;
      }
    } else if (this.view !== 'preferences-view' && (details.properties.status == 'BOOKED' || details.properties.status == 'SIGNED_IN')) {
      this.bookingDisplayData = Object.assign({}, details.properties.bookedByDetails);
      this.bookingDisplaySeat = details.properties.name?details.properties.name:this.empSearchSeat;
      this.shouldDisplayBookingPopUp = this.showEmpBookingDetails;
    } else if (details.properties.status === null && details.properties.seatBookedBydetails.length > 0) {
      //Cases where seatStatus is not captured
      this.bookingDisplayData = Object.assign({}, details.properties.bookedByDetails);
      this.bookingDisplaySeat = details.properties.name?details.properties.name:this.empSearchSeat;
      this.shouldDisplayBookingPopUp = this.showEmpBookingDetails;
    } else {
      if(this.view === 'preferences-view' && 
          (details.properties.status == 'BOOKED' || details.properties.status == 'SIGNED_IN') && 
          details.properties.groupType !== 'HOTSEAT' && details.properties.groupType !== 'TEAM'){
          this.bookingDisplayData = Object.assign({}, details.properties.bookedByDetails);
          this.bookingDisplaySeat = details.properties.name;
          this.shouldDisplayBookingPopUp = this.showEmpBookingDetails;
        return;
      }
      this.dismissPopUp({});
      if (this.seatSelectionAllowed) {
        //If we are selecting the same seat again then just deselect
        let shouldSelectPassedSeat = true;
        this.selectedSeatsList.forEach(element => {
          if (this.multiSelectAllowed) {
            if (element['ID'] === ID) {
              shouldSelectPassedSeat = false;
              this.deSelectSeat(element, currentImage);
            }
          } else {
            this.deSelectSeat(element, currentImage);
          }
        }
        );
        if (shouldSelectPassedSeat) {
          this.selectSeat(details, base, ID, currentImage, width, height, xPos, yPos);
        }
      }
      if (!this.multiSelectAllowed) {
        this.seatClickEmitter.emit(this._dataBridge.cloneObject(details));
      }
    }
    this.showTeamTooltip = this.shouldDisplayBookingPopUp ? false : null;
  }

  selectSeat(details, base, ID?, currentImage?, width?, height?, xPos?, yPos?) {
    if (this.FLOOR_DATA.planDetails.floor.floortype == 'WITH_BACKGROUND_IMAGE') {
      currentImage = (details.styling?.imageName || 'point') + 'Selected'
    } else {
      currentImage = (details.styling?.imageName || 'availableSeatDefault') + 'Selected'
    }
    this.selectedSeatsList.push({
      details,
      base,
      ID,
      currentImage,
      width,
      height,
      xPos,
      yPos
    });
    this.toBePublishedSeatDataList.push({
      amenities: details.properties.amenities || [],
      floorId: this.layout.floorDetails.floorId || '',
      floorName: this.layout.floorDetails.floorName || '',
      lastSanitizationTime: details.properties.extras.lastSanitizationTime || 0,
      polygonId: details.properties.polygonId,
      seatId: details.properties.ID,
      seatName: details.properties.name,
      extras: Object.assign({}, details)
    });
    this.exchangeAsset(details, base, ID, currentImage);
    window.parent.postMessage({
      eventType: 'SEAT_SELECTED',
      app: 'FLOOR_PLAN_LIBRARY',
      value: this.multiSelectAllowed ? this.toBePublishedSeatDataList : this.toBePublishedSeatDataList[this.toBePublishedSeatDataList.length - 1]
    }, '*');
  }

  selectSeatOnGrid(seat, tag?) {
    if(this.view === 'parking-view' && seat.properties.status == "BOOKED") return
    // if (!this.seatSelectionAllowed) {
    //     return;
    // }
    if (seat.properties.status === "Not Available") {
      if (seat.properties.bookedByDetails && seat.properties.bookedByDetails.length > 0) {
        this.bookingDisplayData = Object.assign({}, seat.properties.bookedByDetails);
        this.shouldDisplayBookingPopUp = this.showEmpBookingDetails;
      } else {
        this.dismissPopUp({});
        return;
      }
    }
    if (seat.properties.status == "BOOKED" || seat.properties.status === 'SIGNED_IN') {
      this.base = document.getElementById(seat.properties.ID);
      this.populatePopUpPosition();
      this.bookingDisplayData = Object.assign({}, seat.properties.bookedByDetails);
      this.bookingDisplaySeat = seat.properties.name;
      this.shouldDisplayBookingPopUp = this.showEmpBookingDetails;
      return;
    }
    let selectedSeatOnGrid = {
      amenities: seat.properties.amenities || [],
      floorId: this.layout.floorDetails.floorId || '',
      floorName: this.layout.floorDetails.floorName || '',
      lastSanitizationTime: seat.properties.extras.lastSanitizationTime || 0,
      polygonId: seat.properties.polygonId,
      seatId: seat.properties.ID,
      seatName: seat.properties.name,
      extras: Object.assign({}, seat)
    };
    if(this.view === 'parking-view') selectedSeatOnGrid['tag'] = tag
    this.selectedSeatOnGrid = selectedSeatOnGrid
    if (this.seatSelectionAllowed) {
      //If we are selecting the same seat again then just deselect
      let shouldSelectPassedSeat = true;
      this.selectedSeatsList.forEach(element => {
        if (this.multiSelectAllowed) {
          if (element['seatId'] === seat.properties.ID) {
            shouldSelectPassedSeat = false;
            this.deSelectGridSeat(element);
          }
        } else {
          this.deSelectGridSeat(element);
        }
      });
      if (shouldSelectPassedSeat) {
        this.selectedSeatsList.push(this.selectedSeatOnGrid);
        this.toBePublishedSeatDataList.push(this.selectedSeatOnGrid);
        window.parent.postMessage({
          eventType: 'SEAT_SELECTED',
          app: 'FLOOR_PLAN_LIBRARY',
          value: this.multiSelectAllowed ? this.toBePublishedSeatDataList : this.toBePublishedSeatDataList[this.toBePublishedSeatDataList.length - 1]
        }, '*');
      }
    } else {
      this.seatClickEmitter.emit(this._dataBridge.cloneObject(seat));
    }

  }

  deSelectGridSeat(seatToBeDeselected) {
    let copyOfSelectedSeats = [];
    this.selectedSeatsList.forEach(element => {
      if (element['seatId'] != seatToBeDeselected['seatId']) {
        copyOfSelectedSeats.push(element);
      }
    });
    this.selectedSeatsList = copyOfSelectedSeats;
    this.toBePublishedSeatDataList = this.toBePublishedSeatDataList.filter(item => {
      return item.seatId !== seatToBeDeselected['seatId']
    });
    console.log('seatsList->', this.toBePublishedSeatDataList);
    window.parent.postMessage({
      eventType: 'SEAT_SELECTED',
      app: 'FLOOR_PLAN_LIBRARY',
      value: this.multiSelectAllowed ? this.toBePublishedSeatDataList : this.toBePublishedSeatDataList[this.toBePublishedSeatDataList.length - 1]
    }, '*');
  }

  getGridSeatColor(seat) {
    const availableColors = ['#E9599E', '#8076C0', '#94CBEA', '#F2BF3B', '#98AEE6', '#F5AC78', '#B08F75', '#ACDADA', '#EEAC9F', '#C9C3FB', '#C8D5F6'];
    // let team = (seat['properties']?.groupType=='TEAM' || (seat['properties'].groupType==null && seat['properties'].teamName) ||)?seat['properties']?.teamName:null;
    let team = this.getTeamName(seat.properties.ID);
    if (team) {
      let backgroundColor;
      this.FLOOR_DATA.extras.colorMapping.forEach(label => {
        if (Object.keys(label)[0] == team) {
          backgroundColor = availableColors[parseInt(label[team].match(/\d+/)[0]) - 1];
        }
      });
      return backgroundColor;
    } else {
      if (this.view === 'assignment-view' && seat['properties']?.groupType === 'HOTSEAT') {
        return '#857BFF';
      } else if (this.view === 'assignment-view' && seat['properties']?.groupType === 'BLOCKED') {
        return '#ccd3da';
      } else
        return (seat['properties']?.status === 'AVAILABLE' ? ('#929DAB') : '#CCD3DA');
    }

  }

  getTeamName(_id) {
    let teamName;
    if (this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id]) {
      teamName = this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id].teamName;
    }
    if (!teamName && this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id] && this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id].seatBookedBydetails && this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id].seatBookedBydetails[0]) {
      teamName = this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id].seatBookedBydetails[0].teamName;
    }
    return teamName;
  }



  checkArrayContainsSeatId(id) {
    var found = this.selectedSeatsList.find(o => o.seatId === id)
    if (found === undefined)
      return false;
    else
      return true;
  }

  deSelectSeat(seatToBeDeselected, currentImg) {
    let details = seatToBeDeselected['details'];
    let currentImage = details.styling?.imageName || (this.FLOOR_DATA.planDetails.floor.floortype == "WITH_FLOOR_PLAN" ? 'availableSeatDefault' : 'point')
    if (this.view == 'admin-view' || this.view == "assignment-view") {
      this.exchangeAsset(details, seatToBeDeselected['base'], seatToBeDeselected['ID'], currentImg);
    } else {
      this.teamSeatDeselected = this.view === 'employee-view' &&
          details.properties?.groupType === 'TEAM' && 
          details.properties?.status === 'AVAILABLE'
      this.exchangeAsset(details, seatToBeDeselected['base'], seatToBeDeselected['ID'], currentImage);
    }
    let copyOfSelectedSeats = [];
    this.selectedSeatsList.forEach(element => {
      if (element['ID'] != seatToBeDeselected['ID']) {
        copyOfSelectedSeats.push(element);
      }
    });
    this.selectedSeatsList = copyOfSelectedSeats;
    this.toBePublishedSeatDataList = this.toBePublishedSeatDataList.filter(item => {
      return item.seatId !== seatToBeDeselected['ID']
    });
    console.log('seatsList->', this.toBePublishedSeatDataList);
    window.parent.postMessage({
      eventType: 'SEAT_SELECTED',
      app: 'FLOOR_PLAN_LIBRARY',
      value: this.multiSelectAllowed ? this.toBePublishedSeatDataList : this.toBePublishedSeatDataList[this.toBePublishedSeatDataList.length - 1]
    }, '*');
  }

  exchangeAsset(details, base, ID?, currentImage?,) {
    let seat = d3.select(document.getElementById(ID + "SEAT"));
    let width = seat === null || seat === void 0 ? void 0 : seat.attr('width');
    let height = seat === null || seat === void 0 ? void 0 : seat.attr('height');
    let xPos = seat === null || seat === void 0 ? void 0 : seat.attr('x');
    let yPos = seat === null || seat === void 0 ? void 0 : seat.attr('y');
    let assetExchange = new Promise((resolve, reject) => {
      d3.xml(`${this._dataBridge.getAssetsLocation()}/${currentImage}.svg`)
        .then((data) => {
          d3.select(document.getElementById(ID + "SEAT")).remove();
          if(data.documentElement){
            d3.select(base).append(() => {
              d3.select(data.documentElement)
                .attr("imageName", currentImage)
                .attr("width", width)
                .attr("height", height)
                .attr("id", ID + "SEAT")
                .attr("x", xPos)
                .attr("y", yPos)
                .attr("status", details.properties.status)
                .on("click", (event, i) => {
                  // this.seatClickHandler(details, base, ID, currentImage);
                });
              return data.documentElement;
            });
        }
        }).then((res) => {
          if(this.teamSeatDeselected){
            d3.select(document.getElementById(details.properties.ID + "SEAT")).selectChildren().style('stroke', '#ED711C')
            d3.select(document.getElementById(details.properties.ID + "SEAT")).selectChildren().selectAll('path').classed('cls-1',false).classed('cls-2',false).style("fill","#fff");
            this.teamSeatDeselected = false;
          }
          resolve('done');
        }).catch(()=>{
          reject('Some Error Occured')
        });
    });
    return assetExchange;
  }

  transitionAsset(details, base, ID, currentImage, width, height, xPos, yPos) {
    let element = document.getElementById(ID + "SEAT");
    d3.select(element).selectAll('*').style('fill', '#333').on('click', (event) => {
      d3.select(element).selectAll('*').style('fill', null);
    });
  }

  populatePopUpPosition() {
    let x, y;
    if ((this.platformElement.getBoundingClientRect().right - this.base.getBoundingClientRect().right) > 230) {
      x = this.base.getBoundingClientRect().right;
      y = this.base.getBoundingClientRect().top;
      this.bookingPopUpDirection=true;
    }
    else if ((this.base.getBoundingClientRect().left - this.platformElement.getBoundingClientRect().left) > 230) {
      x = this.base.getBoundingClientRect().left - 235;
      y = this.base.getBoundingClientRect().top;
      this.bookingPopUpDirection=false;
    }
    else if ((this.base.getBoundingClientRect().top - this.platformElement.getBoundingClientRect().top) > 100) {
      x = this.base.getBoundingClientRect().left;
      x = x > 5 ? x : 5;
      x = x + 240 < this.platformElement.getBoundingClientRect().right ? x : this.platformElement.getBoundingClientRect().right - 235;
      y = this.base.getBoundingClientRect().top - 115;
    }
    else {
      x = this.base.getBoundingClientRect().left;
      x = x > 5 ? x : 5;
      x = x + 240 < this.platformElement.getBoundingClientRect().right ? x : this.platformElement.getBoundingClientRect().right - 235;
      y = this.base.getBoundingClientRect().bottom;
    }
    this.popUpPosition = {
      xPos: x,
      yPos: y
    };
  }
  gridParkingComputeScrollWrapperWidth(tagName: string, slotsCount: number){
    if(tagName === 'Available'){
      let computedWidth = Math.ceil(slotsCount / 3) * 99;
      let width = computedWidth >= window.innerWidth ? computedWidth: window.innerWidth - 40
      return `${width}px`;
    }
    else{
      return '100%'
    }
  }
  getParkingSlotImageUrl(seat){
    let seatStatus = seat.properties.status
    let seatId = seat.properties.ID
    let tag = seat.properties.tag
    let svgUrl = this.FLOOR_DATA.extras.assetsLocation + '/parking-view/';
    if(seatId === (<any>this.selectedSeatOnGrid).seatId && tag === (<any>this.selectedSeatOnGrid).tag){
      if(this.parkingType === 'TWO-WHEELER-PARKING') svgUrl += 'bikeSelected.svg'
      else if(this.parkingType === 'FOUR-WHEELER-PARKING') svgUrl += 'carSelected.svg'
    }
    else if(seatStatus === 'BOOKED' && seat.properties.bookedByDetails[0] && seat.properties.bookedByDetails[0].empGuid === this.empGuidParam){
      if(this.parkingType === 'TWO-WHEELER-PARKING') svgUrl += 'bikePastBooked.svg'
      else if(this.parkingType === 'FOUR-WHEELER-PARKING') svgUrl += 'carPastBooked.svg'
    }
    else if(seatStatus === 'BOOKED'){
      if(this.parkingType === 'TWO-WHEELER-PARKING') svgUrl += 'bikeBooked.svg'
      else if(this.parkingType === 'FOUR-WHEELER-PARKING') svgUrl += 'carBooked.svg'
    }
    else if(seatStatus === 'Not Available'){
      if(this.parkingType === 'TWO-WHEELER-PARKING') svgUrl += 'bikeBlocked.svg'
      else if(this.parkingType === 'FOUR-WHEELER-PARKING') svgUrl += 'carBlocked.svg'
    }
    else{
      svgUrl = null
    }
    return svgUrl
  }

  seatFilterHandler() {
    let that = this
    this.selectedSeatOnGrid = {}
    let groups = d3.selectAll("g").each(function seatAssignment(d: any, i) {
      if (d?.properties?.type == "SEAT" && d?.properties?.amenities == that.filter) {
        // console.log(d3.select(document.getElementById(d['properties'].ID)))
        d3.select(document.getElementById(d['properties'].ID)).style('fill', 'green').style("opacity", "1")
        // d3.select(d).select('path')

      }
    });

    if (this.filter.length > 0) {
      let that = this;
      if (this.isFloorPlanAvailable) {
        let groups = d3.selectAll("g").each(function seatAssignment(d: any, i) {
          if (d?.properties?.type == "SEAT") {
            let seatHasAllAmenities = true;
            that.filter.forEach(element => {
              if (!d?.properties?.amenities?.includes(element.name)) {
                seatHasAllAmenities = false;
              }
            });
            if (!seatHasAllAmenities && d?.properties?.status != "Not Available" && d?.properties?.status != "BOOKED") {
              that.filteredSeats.push(that._dataBridge.cloneObject(d?.properties));
              d.properties.status = "Not Available";
              let seat = document.getElementById(d?.properties?.ID);
              let baseGroup = seat.parentElement;
              let currentImage = (d?.styling?.imageName ?
                d?.styling?.imageName :
                (that.FLOOR_DATA.planDetails.floor.floortype == "WITH_FLOOR_PLAN" ? 'availableSeatDefault' : 'point')
              ) + "Unavailable";
              that.exchangeAsset(d, baseGroup, d.properties.ID, currentImage);
            }
          }
        });
      }
      else {
        let seats = this._dataBridge.getSeatsList();
        this.seats = [...this._dataBridge.getSeatsList()];
        seats.forEach(seat => {
          this.filter.forEach(element => {
            if (!seat.properties.amenities.includes(element.name) && seat.properties.status == "AVAILABLE") {
              seat.properties.status = "Not Available";
            }
          });
        });

        this.categorizeSeatsForNoFloorPlan(seats);
      }
    }
  }

  async resetFilters() {
    let that = this;
    let exchangeResult = [];
    if (!this.isFloorPlanAvailable) {
      this.categorizeSeatsForNoFloorPlan(this._dataBridge.getSeatsList());
    }
    d3.selectAll("g").each(function seatAssignment(d: any, i) {

      if (d?.properties?.type == "SEAT") {
        for (let element of that.filteredSeats) {
          if (d?.properties?.ID == element.ID) {
            d.properties = that._dataBridge.cloneObject(element);
            let seat = document.getElementById(d?.properties?.ID);
            let baseGroup = seat.parentElement;
            let currentImage = (d?.styling?.imageName) || (that.FLOOR_DATA.planDetails.floor.floortype == "WITH_FLOOR_PLAN" ? 'availableSeatDefault' : 'point');
            switch (d.properties.status) {
              case 'Not Available':
                currentImage += "Unavailable";
                break;
              case 'BOOKED':
                currentImage += "Booked";
                break;
            }
            exchangeResult.push(that.exchangeAsset(d, baseGroup, d.properties.ID, currentImage));
          }
        }
      }
    });
    await exchangeResult;
    this.filteredSeats = [];
  }

  dismissPopUp(event) {
    this.shouldDisplayBookingPopUp = false;
  }

  teamDismissPopUp(event){
    this.showTeamTooltip = false;
  }
  checkIfBookedSlotIsPastBooking(seat): boolean {
    if(seat.properties.status === 'BOOKED' && seat.properties.bookedByDetails[0].empGuid === this.empGuidParam){
      return true
    }
    return false
  }
}
